module.exports = __webpack_public_path__ + "img/營造業工地主任職能訓練講習結業證書.f2906b87.jpg";